











































import { Fragment } from 'vue-fragment';
import Vue from 'vue';

export default Vue.extend({
    name: 'tab-view',
    components: { Fragment },
    props: {
        visible: {
            type: Boolean,
            required: false,
            default: () : boolean | undefined => undefined,
        },
        alternateText: { type: String },
    },
});
